// src/components/HomePage.js
import React from "react";

const HomePage = () => {
    return (
        <div>
            <h1> </h1>
        </div>
    );
};

export default HomePage;
